export const groupFields = (data: AnyObject[]) => {
    const items: { value: string | number; label: string }[] = [];
    let firstItem: any = { value: [], label: [] };

    data.forEach((it: any) => {
        items.push({ value: it.id, label: it.title });
        firstItem.label.push(it.title);
        firstItem.value = 'all';
    });
    items.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    if (items.length) {
        firstItem.label = firstItem.label.join(',');
    } else {
        firstItem = false;
    }
    return { items, firstItem };
};
